export default "__VITE_ASSET__DhnANFng__"